export const SET_SCREEN_PROPERTIES = 'SET_SCREEN_PROPERTIES';

export const AUTHENTICATE_USER = 'AUTHENTICATE_USER';
export const AUTHENTICATE_USER_SUCCESS = 'AUTHENTICATE_USER_SUCCESS';
export const AUTHENTICATE_USER_FAILURE = 'AUTHENTICATE_USER_FAILURE';
export const SIGN_IN_USER = 'SIGN_IN_USER';
export const SIGN_IN_SUCCSESS = 'SIGN_IN_SUCCSESS';
export const SIGN_IN_FAILURE = 'SIGN_IN_FAILURE';
export const SET_NOT_FIRST_TO_SELECT_PAGE = 'SET_NOT_FIRST_TO_SELECT_PAGE';
export const LOG_OUT = 'LOG_OUT';

export const DOWNLOAD_AUDIENCE = 'DOWNLOAD_AUDIENCE';
export const DOWNLOAD_AUDIENCE_SUCCESS = 'DOWNLOAD_AUDIENCE_SUCCESS';
export const DOWNLOAD_AUDIENCE_FAILURE = 'DOWNLOAD_AUDIENCE_FAILURE';

export const FETCH_CLIENT = 'FETCH_CLIENT';
export const FETCH_CLIENT_ERROR = 'FETCH_CLIENT_ERROR';
export const SET_CLIENT = 'SET_CLIENT';

export const SET_HOME_DATE_RANGE = 'SET_HOME_DATE_RANGE';
export const SET_HOME_DATE_RANGE_PRESET = 'SET_HOME_DATE_RANGE_PRESET';
export const SET_HOME_DATE_RANGE_ALL_TIME = 'SET_HOME_DATE_RANGE_ALL_TIME';

export const SERVER_STATUS_CHECKING = 'SERVER_STATUS_CHECKING';
export const SERVER_STATUS_OK = 'SERVER_STATUS_OK';
export const SERVER_STATUS_ERROR = 'SERVER_STATUS_ERROR';

// Reports
export const SET_SELECTED_REPORT = 'SET_SELECTED_REPORT';
export const SET_SELECTED_REPORT_BY_ID = 'SET_SELECTED_REPORT_BY_ID';

// Location
export const FETCH_BOUNDARIES = 'FETCH_BOUNDARIES';
export const FETCH_BOUNDARIES_ERROR = 'FETCH_BOUNDARIES_ERROR';
export const SET_BOUNDARIES = 'SET_REGIONAL_AREA_DATA';

export const FETCH_REGIONAL_AREA_DATA = 'FETCH_REGIONAL_AREA_DATA';
export const FETCH_REGIONAL_AREA_DATA_ERROR = 'FETCH_REGIONAL_AREA_DATA_ERROR';
export const SET_REGIONAL_AREA_DATA = 'SET_REGIONAL_AREA_DATA';

export const FETCH_CITIES_DATA = 'FETCH_CITIES_DATA';
export const FETCH_CITIES_DATA_ERROR = 'FETCH_CITIES_DATA_ERROR';
export const SET_CITIES_DATA = 'SET_CITIES_DATA';

export const FETCH_DISTRICTS_DATA = 'FETCH_DISTRICTS_DATA';
export const FETCH_DISTRICTS_DATA_ERROR = 'FETCH_DISTRICTS_DATA_ERROR';
export const SET_DISTRICTS_DATA = 'SET_DISTRICTS_DATA';

export const FETCH_SUBURBS_DATA = 'FETCH_SUBURBS_DATA';
export const FETCH_SUBURBS_DATA_ERROR = 'FETCH_SUBURBS_DATA_ERROR';
export const SET_SUBURBS_DATA = 'SET_SUBURBS_DATA';

export const SET_INSIGHTS_CRITERIA_TYPE = 'SET_INSIGHTS_CRITERIA_TYPE';
export const SET_INSIGHTS_CRITERIA_DATE_RANGE =
  'SET_INSIGHTS_CRITERIA_DATE_RANGE';
export const SET_INSIGHTS_CRITERIA_ORGANISATION =
  'SET_INSIGHTS_CRITERIA_ORGANISATION';
export const SET_INSIGHTS_CRITERIA_SUBCATEGORY =
  'SET_INSIGHTS_CRITERIA_SUBCATEGORY';
export const SET_INSIGHTS_CRITERIA_BOUNDARIES =
  'SET_INSIGHTS_CRITERIA_BOUNDARIES';
export const SET_INSIGHTS_CRITERIA_POI = 'SET_INSIGHTS_CRITERIA_POI';
export const SET_INSIGHTS_CRITERIA_MOBILE_APP =
  'SET_INSIGHTS_CRITERIA_MOBILE_APP';
export const SET_INSIGHTS_CRITERIA_FOOTFALL_OVER_TIME_UNIT =
  'SET_INSIGHTS_CRITERIA_FOOTFALL_OVER_TIME_UNIT';
export const SET_FROM_LAST_PAGE = 'SET_FROM_LAST_PAGE';
export const CLEAR_INSIGHTS_CRITERIA = 'CLEAR_INSIGHTS_CRITERIA';
export const CLEAR_INSIGHTS_CRITERIA_BOUNDARIES =
  'CLEAR_INSIGHTS_CRITERIA_BOUNDARIES';
export const CLEAR_INSIGHTS_CRITERIA_POIS = 'CLEAR_INSIGHTS_CRITERIA_POIS';
export const CLEAR_INSIGHTS_CRITERIA_MOBILE_APP =
  'CLEAR_INSIGHTS_CRITERIA_MOBILE_APP';
export const TOGGLE_STATISTIC_DISPLAY = 'TOGGLE_STATISTIC_DISPLAY';

export const FETCH_HOME_SUMMARY = 'FETCH_HOME_SUMMARY';
export const FETCH_HOME_SUMMARY_ERROR = 'FETCH_HOME_SUMMARY_ERROR';
export const SET_HOME_SUMMARY = 'SET_HOME_SUMMARY';
export const FETCH_POI_COUNT = 'FETCH_POI_COUNT';
export const FETCH_POI_COUNT_ERROR = 'FETCH_POI_COUNT_ERROR';
export const SET_POI_COUNT = 'SET_POI_COUNT';
export const FETCH_HOME_ORGANISATIONS = 'FETCH_HOME_ORGANISATIONS';
export const FETCH_HOME_ORGANISATIONS_ERROR = 'FETCH_HOME_ORGANISATIONS_ERROR';
export const SET_HOME_ORGANISATIONS = 'SET_HOME_ORGANISATIONS';
export const FETCH_CATEGORIES = 'FETCH_CATEGORIES';
export const FETCH_CATEGORIES_ERROR = 'FETCH_CATEGORIES_ERROR';
export const SET_CATEGORIES = 'SET_CATEGORIES';
export const FETCH_PROSPECTS_TO_WATCH_DATA = 'FETCH_PROSPECTS_TO_WATCH_DATA';
export const FETCH_PROSPECTS_TO_WATCH_DATA_ERROR =
  'FETCH_PROSPECTS_TO_WATCH_DATA_ERROR';
export const SET_PROSPECTS_TO_WATCH_DATA = 'SET_PROSPECTS_TO_WATCH_DATA';
export const FETCH_WHERE_YOUR_CUSTOMERS_HAVE_BEEN =
  'FETCH_WHERE_YOUR_CUSTOMERS_HAVE_BEEN';
export const FETCH_WHERE_YOUR_CUSTOMERS_HAVE_BEEN_ERROR =
  'FETCH_WHERE_YOUR_CUSTOMERS_HAVE_BEEN_ERROR';
export const SET_WHERE_YOUR_CUSTOMERS_HAVE_BEEN =
  'SET_WHERE_YOUR_CUSTOMERS_HAVE_BEEN';
export const FETCH_BIGGEST_MOVERS = 'FETCH_BIGGEST_MOVERS';
export const FETCH_BIGGEST_MOVERS_ERROR = 'FETCH_BIGGEST_MOVERS_ERROR';
export const SET_BIGGEST_MOVERS = 'SET_BIGGEST_MOVERS';
// Footfall insight
export const FETCH_INSIGHTS_SUMMARY = 'FETCH_INSIGHTS_SUMMARY';
export const FETCH_INSIGHTS_SUMMARY_ERROR = 'FETCH_INSIGHTS_SUMMARY_ERROR';
export const SET_INSIGHTS_SUMMARY = 'SET_INSIGHTS_SUMMARY';
export const FETCH_DAILY_AVERAGES = 'FETCH_DAILY_AVERAGES';
export const FETCH_DAILY_AVERAGES_ERROR = 'FETCH_DAILY_AVERAGES_ERROR';
export const SET_DAILY_AVERAGES = 'SET_DAILY_AVERAGES';
export const FETCH_INSIGHTS_FOOTFALL = 'FETCH_INSIGHTS_FOOTFALL';
export const FETCH_INSIGHTS_FOOTFALL_ERROR = 'FETCH_INSIGHTS_FOOTFALL_ERROR';
export const SET_INSIGHTS_FOOTFALL = 'SET_INSIGHTS_FOOTFALL';
export const SELECT_INSIGHTS_TIME_PERIOD = 'SELECT_INSIGHTS_TIME_PERIOD';
export const FETCH_INSIGHTS_POI_COUNT = 'FETCH_INSIGHTS_POI_COUNT';
export const FETCH_INSIGHTS_POI_COUNT_ERROR = 'FETCH_INSIGHTS_POI_COUNT_ERROR';
export const SET_INSIGHTS_POI_COUNT = 'SET_INSIGHTS_POI_COUNT';

export const FETCH_INSIGHTS_FOOTFALL_OVER_TIME =
  'FETCH_INSIGHTS_FOOTFALL_OVER_TIME';
export const FETCH_INSIGHTS_FOOTFALL_OVER_TIME_ERROR =
  'FETCH_INSIGHTS_FOOTFALL_OVER_TIME_ERROR';
export const SET_INSIGHTS_FOOTFALL_OVER_TIME =
  'SET_INSIGHTS_FOOTFALL_OVER_TIME';

export const FETCH_INSIGHTS_FOOTFALL_PERCENTAGE =
  'FETCH_INSIGHTS_FOOTFALL_PERCENTAGE';
export const FETCH_INSIGHTS_FOOTFALL_PERCENTAGE_ERROR =
  'FETCH_INSIGHTS_FOOTFALL_PERCENTAGE_ERROR';
export const SET_INSIGHTS_FOOTFALL_PERCENTAGE =
  'SET_INSIGHTS_FOOTFALL_PERCENTAGE';

export const FETCH_INSIGHTS_REPEAT_VS_UNIQUE =
  'FETCH_INSIGHTS_REPEAT_VS_UNIQUE';
export const FETCH_INSIGHTS_REPEAT_VS_UNIQUE_ERROR =
  'FETCH_INSIGHTS_REPEAT_VS_UNIQUE_ERROR';
export const SET_INSIGHTS_REPEAT_VS_UNIQUE = 'SET_INSIGHTS_REPEAT_VS_UNIQUE';
// Travel past
export const SELECT_TRAVEL_PAST_AVERAGE = 'SELECT_TRAVEL_PAST_AVERAGE';
export const FETCH_TRAVEL_PAST_SUMMARY = 'FETCH_TRAVEL_PAST_SUMMARY';
export const FETCH_TRAVEL_PAST_SUMMARY_ERROR =
  'FETCH_TRAVEL_PAST_SUMMARY_ERROR';
export const SET_TRAVEL_PAST_SUMMARY = 'SET_TRAVEL_PAST_SUMMARY';
export const FETCH_TRAVEL_PAST_POI_COUNT = 'FETCH_TRAVEL_PAST_POI_COUNT';
export const FETCH_TRAVEL_PAST_POI_COUNT_ERROR =
  'FETCH_TRAVEL_PAST_POI_COUNT_ERROR';
export const SET_TRAVEL_PAST_POI_COUNT = 'SET_TRAVEL_PAST_POI_COUNT';
export const FETCH_TRAVEL_PAST_OVER_TIME = 'FETCH_TRAVEL_PAST_OVER_TIME';
export const FETCH_TRAVEL_PAST_OVER_TIME_ERROR =
  'FETCH_TRAVEL_PAST_OVER_TIME_ERROR';
export const SET_TRAVEL_PAST_OVER_TIME = 'SET_TRAVEL_PAST_OVER_TIME';
export const FETCH_TRAVEL_PAST_DAILY_AVERAGES =
  'FETCH_TRAVEL_PAST_DAILY_AVERAGES';
export const FETCH_TRAVEL_PAST_DAILY_AVERAGES_ERROR =
  'FETCH_TRAVEL_PAST_DAILY_AVERAGES_ERROR';
export const SET_TRAVEL_PAST_DAILY_AVERAGES = 'SET_TRAVEL_PAST_DAILY_AVERAGES';
export const FETCH_TRAVEL_PAST_POIS = 'FETCH_TRAVEL_PAST_POIS';
export const FETCH_TRAVEL_PAST_POIS_ERROR = 'FETCH_TRAVEL_PAST_POIS_ERROR';
export const SET_TRAVEL_PAST_POIS = 'SET_TRAVEL_PAST_POIS';
export const FETCH_TRAVEL_PAST_REPEAT_DEVICES =
  'FETCH_TRAVEL_PAST_REPEAT_DEVICES';
export const FETCH_TRAVEL_PAST_REPEAT_DEVICES_ERROR =
  'FETCH_TRAVEL_PAST_REPEAT_DEVICES_ERROR';
export const SET_TRAVEL_PAST_REPEAT_DEVICES = 'SET_TRAVEL_PAST_REPEAT_DEVICES';
export const DOWNLOAD_TRAVEL_PAST_INSIGHTS = 'DOWNLOAD_TRAVEL_PAST_INSIGHTS';
export const DOWNLOAD_TRAVEL_PAST_INSIGHTS_SUCCESS =
  'DOWNLOAD_TRAVEL_PAST_INSIGHTS_SUCCESS';
export const DOWNLOAD_TRAVEL_PAST_INSIGHTS_FAILURE =
  'DOWNLOAD_TRAVEL_PAST_INSIGHTS_FAILURE';
export const LOAD_TRAVEL_PAST_MOCK_DATA = 'LOAD_TRAVEL_PAST_MOCK_DATA';
export const SELECT_TRAVEL_PAST_TIME_PERIOD = 'SELECT_TRAVEL_PAST_TIME_PERIOD';

// Account Actions
export const FETCH_ACCOUNT_LIST = 'FETCH_ACCOUNT_LIST';
export const FETCH_ACCOUNT_LIST_ERROR = 'FETCH_ACCOUNT_LIST_ERROR';
export const SET_ACCOUNT_LIST = 'SET_ACCOUNT_LIST';

export const CREATE_NEW_ACCOUNT = 'CREATE_NEW_ACCOUNT';
export const CREATE_NEW_ACCOUNT_SUCCESS = 'CREATE_NEW_ACCOUNT_SUCCESS';
export const CREATE_NEW_ACCOUNT_FAILED = 'CREATE_NEW_ACCOUNT_FAILED';

export const FETCH_ACCOUNT_DETAILS = 'FETCH_ACCOUNT_DETAILS';
export const FETCH_ACCOUNT_DETAILS_ERROR = 'FETCH_ACCOUNT_DETAILS_ERROR';
export const SET_ACCOUNT_DETAILS = 'SET_ACCOUNT_DETAILS';

export const DELETE_ACCOUNT = 'DELETE_ACCOUNT';
export const DELETE_ACCOUNT_SUCCESS = 'DELETE_ACCOUNT_SUCCESS';
export const DELETE_ACCOUNT_FAILED = 'DELETE_ACCOUNT_FAILED';

export const UPDATE_ACCOUNT = 'UPDATE_ACCOUNT';
export const UPDATE_ACCOUNT_SUCCESS = 'UPDATE_ACCOUNT_SUCCESS';
export const UPDATE_ACCOUNT_FAILED = 'UPDATE_ACCOUNT_FAILED';

export const FETCH_ACCOUNT_PERMISSIONS = 'FETCH_ACCOUNT_PERMISSIONS';
export const FETCH_ACCOUNT_PERMISSIONS_ERROR =
  'FETCH_ACCOUNT_PERMISSIONS_ERROR';
export const SET_ACCOUNT_PERMISSIONS = 'SET_ACCOUNT_PERMISSIONS';

export const ASSOCIATE_ROLES_WITH_ACCOUNT = 'ASSOCIATE_ROLES_WITH_ACCOUNT';
export const ASSOCIATE_ROLES_WITH_ACCOUNT_SUCCESS =
  'ASSOCIATE_ROLES_WITH_ACCOUNT_SUCCESS';
export const ASSOCIATE_ROLES_WITH_ACCOUNT_FAILED =
  'ASSOCIATE_ROLES_WITH_ACCOUNT_FAILED';

export const FETCH_ACCOUNT_OVERVIEW = 'FETCH_ACCOUNT_OVERVIEW';
export const FETCH_ACCOUNT_OVERVIEW_ERROR = 'FETCH_ACCOUNT_OVERVIEW_ERROR';
export const SET_ACCOUNT_OVERVIEW = 'SET_ACCOUNT_OVERVIEW';

export const RESET_ACCOUNT_PASSWORD = 'RESET_ACCOUNT_PASSWORD';
export const RESET_ACCOUNT_PASSWORD_SUCCESS = 'RESET_ACCOUNT_PASSWORD_SUCCESS';
export const RESET_ACCOUNT_PASSWORD_FAILED = 'RESET_ACCOUNT_PASSWORD_FAILED';

export const UPDATE_PERSONAL_DETAILS = 'UPDATE_PERSONAL_DETAILS';
export const UPDATE_PERSONAL_DETAILS_SUCCESS =
  'UPDATE_PERSONAL_DETAILS_SUCCESS';
export const UPDATE_PERSONAL_DETAILS_FAILED = 'UPDATE_PERSONAL_DETAILS_FAILED';

export const REQUEST_PASSWORD_RESET_EMAIL = 'REQUEST_PASSWORD_RESET_EMAIL';
export const REQUEST_PASSWORD_RESET_EMAIL_SUCCESS =
  'REQUEST_PASSWORD_RESET_EMAIL_SUCCESS';
export const REQUEST_PASSWORD_RESET_EMAIL_FAILED =
  'REQUEST_PASSWORD_RESET_EMAIL_FAILED';

// System Modals
export const CLOSE_ALL_MODALS = 'CLOSE_ALL_MODALS';
export const REMOVE_ALL_MODALS = 'REMOVE_ALL_MODALS';
export const PUSH_MODAL = 'PUSH_MODAL';
export const REMOVE_MODAL_BY_ID = 'REMOVE_MODAL_BY_ID';
export const CLOSE_MODAL_BY_ID = 'CLOSE_MODAL_BY_ID';

// Home Insights
export const FETCH_HOME_INSIGHTS_HEATMAP = 'FETCH_HOME_INSIGHTS_HEATMAP';
export const FETCH_HOME_INSIGHTS_HEATMAP_ERROR =
  'FETCH_HOME_INSIGHTS_HEATMAP_ERROR';
export const SET_HOME_INSIGHTS_HEATMAP = 'SET_HOME_INSIGHTS_HEATMAP';
export const FETCH_HOME_INSIGHTS_SUMMARY = 'FETCH_HOME_INSIGHTS_SUMMARY';
export const FETCH_HOME_INSIGHTS_SUMMARY_ERROR =
  'FETCH_HOME_INSIGHTS_SUMMARY_ERROR';
export const SET_HOME_INSIGHTS_SUMMARY = 'SET_HOME_INSIGHTS_SUMMARY';
export const FETCH_HOME_INSIGHTS_LOCATIONS = 'FETCH_HOME_INSIGHTS_LOCATIONS';
export const FETCH_HOME_INSIGHTS_LOCATIONS_ERROR =
  'FETCH_HOME_INSIGHTS_LOCATIONS_ERROR';
export const SET_HOME_INSIGHTS_LOCATIONS = 'SET_HOME_INSIGHTS_LOCATIONS';
export const FETCH_HOME_INSIGHTS_MOSTPOI = 'FETCH_HOME_INSIGHTS_MOSTPOI';
export const FETCH_HOME_INSIGHTS_MOSTPOI_ERROR =
  'FETCH_HOME_INSIGHTS_MOSTPOI_ERROR';
export const SET_HOME_INSIGHTS_MOSTPOI = 'SET_HOME_INSIGHTS_MOSTPOI';
export const FETCH_HOME_INSIGHTS_ELECTORIAL = 'FETCH_HOME_INSIGHTS_ELECTORIAL';
export const FETCH_HOME_INSIGHTS_ELECTORIAL_ERROR =
  'FETCH_HOME_INSIGHTS_ELECTORIAL_ERROR';
export const SET_HOME_INSIGHTS_ELECTORIAL = 'SET_HOME_INSIGHTS_ELECTORIAL';
export const FETCH_HOME_INSIGHTS_SUBURBINFO = 'FETCH_HOME_INSIGHTS_SUBURBINFO';
export const FETCH_HOME_INSIGHTS_SUBURBINFO_ERROR =
  'FETCH_HOME_INSIGHTS_SUBURBINFO_ERROR';
export const SET_HOME_INSIGHTS_SUBURBINFO = 'SET_HOME_INSIGHTS_SUBURBINFO';
export const FETCH_HOME_INSIGHTS_BRANDAFFINITY =
  'FETCH_HOME_INSIGHTS_BRANDAFFINITY';
export const FETCH_HOME_INSIGHTS_BRANDAFFINITY_ERROR =
  'FETCH_HOME_INSIGHTS_BRANDAFFINITY_ERROR';
export const SET_HOME_INSIGHTS_BRANDAFFINITY =
  'SET_HOME_INSIGHTS_BRANDAFFINITY';
export const FETCH_HOME_INSIGHTS_WORK_LOCATIONS =
  'FETCH_HOME_INSIGHTS_WORK_LOCATIONS';
export const FETCH_HOME_INSIGHTS_WORK_LOCATIONS_ERROR =
  'FETCH_HOME_INSIGHTS_WORK_LOCATIONS_ERROR';
export const SET_HOME_INSIGHTS_WORK_LOCATIONS =
  'SET_HOME_INSIGHTS_WORK_LOCATIONS';
export const DOWNLOAD_HOME_INSIGHTS = 'DOWNLOAD_HOME_INSIGHTS';
export const DOWNLOAD_HOME_INSIGHTS_SUCCESS = 'DOWNLOAD_HOME_INSIGHTS_SUCCESS';
export const DOWNLOAD_HOME_INSIGHTS_FAILURE = 'DOWNLOAD_HOME_INSIGHTS_FAILURE';

// Work Insights
export const FETCH_WORK_INSIGHTS_HEATMAP = 'FETCH_WORK_INSIGHTS_HEATMAP';
export const FETCH_WORK_INSIGHTS_HEATMAP_ERROR =
  'FETCH_WORK_INSIGHTS_HEATMAP_ERROR';
export const SET_WORK_INSIGHTS_HEATMAP = 'SET_WORK_INSIGHTS_HEATMAP';
export const FETCH_WORK_INSIGHTS_SUMMARY = 'FETCH_WORK_INSIGHTS_SUMMARY';
export const FETCH_WORK_INSIGHTS_SUMMARY_ERROR =
  'FETCH_WORK_INSIGHTS_SUMMARY_ERROR';
export const SET_WORK_INSIGHTS_SUMMARY = 'SET_WORK_INSIGHTS_SUMMARY';
export const FETCH_WORK_INSIGHTS_LOCATIONS = 'FETCH_WORK_INSIGHTS_LOCATIONS';
export const FETCH_WORK_INSIGHTS_LOCATIONS_ERROR =
  'FETCH_WORK_INSIGHTS_LOCATIONS_ERROR';
export const SET_WORK_INSIGHTS_LOCATIONS = 'SET_WORK_INSIGHTS_LOCATIONS';
export const FETCH_WORK_INSIGHTS_MOSTPOI = 'FETCH_WORK_INSIGHTS_MOSTPOI';
export const FETCH_WORK_INSIGHTS_MOSTPOI_ERROR =
  'FETCH_WORK_INSIGHTS_MOSTPOI_ERROR';
export const SET_WORK_INSIGHTS_MOSTPOI = 'SET_WORK_INSIGHTS_MOSTPOI';
export const FETCH_WORK_INSIGHTS_SUBURBINFO = 'FETCH_WORK_INSIGHTS_SUBURBINFO';
export const FETCH_WORK_INSIGHTS_SUBURBINFO_ERROR =
  'FETCH_WORK_INSIGHTS_SUBURBINFO_ERROR';
export const SET_WORK_INSIGHTS_SUBURBINFO = 'SET_WORK_INSIGHTS_SUBURBINFO';
export const FETCH_WORK_INSIGHTS_BRANDAFFINITY =
  'FETCH_WORK_INSIGHTS_BRANDAFFINITY';
export const FETCH_WORK_INSIGHTS_BRANDAFFINITY_ERROR =
  'FETCH_WORK_INSIGHTS_BRANDAFFINITY_ERROR';
export const SET_WORK_INSIGHTS_BRANDAFFINITY =
  'SET_WORK_INSIGHTS_BRANDAFFINITY';
export const FETCH_WORK_INSIGHTS_LOCATION_TYPES =
  'FETCH_WORK_INSIGHTS_LOCATION_TYPES';
export const FETCH_WORK_INSIGHTS_LOCATION_TYPES_ERROR =
  'FETCH_WORK_INSIGHTS_LOCATION_TYPES_ERROR';
export const SET_WORK_INSIGHTS_LOCATION_TYPES =
  'SET_WORK_INSIGHTS_LOCATION_TYPES';
export const FETCH_WORK_INSIGHTS_HOME_LOCATIONS =
  'FETCH_WORK_INSIGHTS_HOME_LOCATIONS';
export const FETCH_WORK_INSIGHTS_HOME_LOCATIONS_ERROR =
  'FETCH_WORK_INSIGHTS_HOME_LOCATIONS_ERROR';
export const SET_WORK_INSIGHTS_HOME_LOCATIONS =
  'SET_WORK_INSIGHTS_HOME_LOCATIONS';

// BrandAffinity Insights
export const FETCH_BRAND_AFFINITY_BRANDS_REPORT =
  'FETCH_BRAND_AFFINITY_BRANDS_REPORT';
export const FETCH_BRAND_AFFINITY_BRANDS_REPORT_ERROR =
  'FETCH_BRAND_AFFINITY_BRANDS_REPORT_ERROR';
export const SET_BRAND_AFFINITY_BRANDS_REPORT =
  'SET_BRAND_AFFINITY_BRANDS_REPORT';
export const FETCH_BRAND_AFFINITY_CATEGORIES_REPORT =
  'FETCH_BRAND_AFFINITY_CATEGORIES_REPORT';
export const FETCH_BRAND_AFFINITY_CATEGORIES_REPORT_ERROR =
  'FETCH_BRAND_AFFINITY_CATEGORIES_REPORT_ERROR';
export const SET_BRAND_AFFINITY_CATEGORIES_REPORT =
  'SET_BRAND_AFFINITY_CATEGORIES_REPORT';
export const FETCH_BRAND_AFFINITY_TOP_TOIS_REPORT =
  'FETCH_BRAND_AFFINITY_TOP_TOIS_REPORT';
export const FETCH_BRAND_AFFINITY_TOP_TOIS_REPORT_ERROR =
  'FETCH_BRAND_AFFINITY_TOP_TOIS_REPORT_ERROR';
export const SET_BRAND_AFFINITY_TOP_TOIS_REPORT =
  'SET_BRAND_AFFINITY_TOP_TOIS_REPORT';
export const FETCH_BRAND_AFFINITY_ORGANISATION_OPTIONS =
  'FETCH_BRAND_AFFINITY_ORGANISATION_OPTIONS';
export const FETCH_BRAND_AFFINITY_ORGANISATION_OPTIONS_ERROR =
  'FETCH_BRAND_AFFINITY_ORGANISATION_OPTIONS_ERROR';
export const SET_BRAND_AFFINITY_ORGANISATION_OPTIONS =
  'SET_BRAND_AFFINITY_ORGANISATION_OPTIONS';
export const FETCH_CATEGORY_AFFINITY_TOP_TOIS_REPORT =
  'FETCH_CATEGORY_AFFINITY_TOP_TOIS_REPORT';
export const FETCH_CATEGORY_AFFINITY_TOP_TOIS_REPORT_ERROR =
  'FETCH_CATEGORY_AFFINITY_TOP_TOIS_REPORT_ERROR ';
export const SET_CATEGORY_AFFINITY_TOP_TOIS_REPORT =
  'SET_CATEGORY_AFFINITY_TOP_TOIS_REPORT';
export const FETCH_BRAND_AFFINITY_SUBCATEGORIES_OPTIONS =
  'FETCH_BRAND_AFFINITY_SUBCATEGORIES_OPTIONS';
export const FETCH_BRAND_AFFINITY_SUBCATEGORIES_OPTIONS_ERROR =
  'FETCH_BRAND_AFFINITY_SUBCATEGORIES_OPTIONS_ERROR';
export const SET_BRAND_AFFINITY_SUBCATEGORIES_OPTIONS =
  'SET_BRAND_AFFINITY_SUBCATEGORIES_OPTIONS';
export const SET_BRAND_AFFINITY_TOP_POIS_ORGANISATION_OPTION =
  'SET_BRAND_AFFINITY_TOP_POIS_ORGANISATION_OPTION';
export const SET_BRAND_AFFINITY_TOP_POIS_SUBCATEGORIES_OPTION =
  'SET_BRAND_AFFINITY_TOP_POIS_SUBCATEGORIES_OPTION';
export const DOWNLOAD_BRAND_AFFINITY_INSIGHTS =
  'DOWNLOAD_BRAND_AFFINITY_INSIGHTS';
export const DOWNLOAD_BRAND_AFFINITY_INSIGHTS_SUCCESS =
  'DOWNLOAD_BRAND_AFFINITY_INSIGHTS_SUCCESS';
export const DOWNLOAD_BRAND_AFFINITY_INSIGHTS_FAILURE =
  'DOWNLOAD_BRAND_AFFINITY_INSIGHTS_FAILURE';
export const SELECT_BRAND_AFFINITY_TIME_PERIOD =
  'SELECT_BRAND_AFFINITY_TIME_PERIOD';
export const FETCH_BRAND_AFFINITY_SUMMARYCARD =
  'FETCH_BRAND_AFFINITY_SUMMARYCARD';
export const FETCH_BRAND_AFFINITY_SUMMARYCARD_ERROR =
  'FETCH_BRAND_AFFINITY_SUMMARYCARD_ERROR';
export const SET_BRAND_AFFINITY_SUMMARYCARD = 'SET_BRAND_AFFINITY_SUMMARYCARD';
export const CLEAR_BRAND_AFFINITY_TOP_POI_OPTIONS =
  'CLEAR_BRAND_AFFINITY_TOP_POI_OPTIONS';

// pois (Point of interseted)
export const FETCH_POIS = 'FETCH_POIS';
export const FETCH_POIS_ERROR = 'FETCH_POIS_ERROR';
export const SET_POIS = 'SET_POIS';

// mobile apps list
export const FETCH_MOBILE_APPS_LIST = 'FETCH_MOBILE_APPS_LIST';
export const FETCH_MOBILE_APPS_LIST_ERROR = 'FETCH_MOBILE_APPS_LIST_ERROR';
export const SET_MOBILE_APPS_LIST = 'SET_MOBILE_APPS_LIST';

//  Mobile Devices Insights
export const FETCH_MOBILE_DEVICES_APPLICATION_REPORT =
  'FETCH_MOBILE_DEVICES_APPLICATION_REPORT';
export const FETCH_MOBILE_DEVICES_APPLICATION_REPORT_ERROR =
  'FETCH_MOBILE_DEVICES_APPLICATION_REPORT_ERROR';
export const SET_MOBILE_DEVICES_APPLICATION_REPORT =
  'SET_MOBILE_DEVICES_APPLICATION_REPORT';
export const FETCH_MOBILE_DEVICES_SUMMARYCARD =
  'FETCH_MOBILE_DEVICES_SUMMARYCARD';
export const FETCH_MOBILE_DEVICES_SUMMARYCARD_ERROR =
  'FETCH_MOBILE_DEVICES_SUMMARYCARD_ERROR';
export const SET_MOBILE_DEVICES_SUMMARYCARD = 'SET_MOBILE_DEVICES_SUMMARYCARD';
export const DOWNLOAD_MOBILE_DEVICES_INSIGHTS =
  'DOWNLOAD_MOBILE_DEVICES_INSIGHTS';
export const DOWNLOAD_MOBILE_DEVICES_INSIGHTS_SUCCESS =
  'DOWNLOAD_MOBILE_DEVICES_INSIGHTS_SUCCESS';
export const DOWNLOAD_MOBILE_DEVICES_INSIGHTS_FAILURE =
  'DOWNLOAD_MOBILE_DEVICES_INSIGHTS_FAILURE';
export const FETCH_MOBILE_DEVICES_REPORT = 'FETCH_MOBILE_DEVICES_REPORT';
export const FETCH_MOBILE_DEVICES_REPORT_ERROR = 'FETCH_MOBILE_DEVICES_ERROR';
export const SET_FETCH_MOBILE_DEVICES_REPORT =
  'SET_FETCH_MOBILE_DEVICES_REPORT';
export const FETCH_MOBILE_DEVICES_NETWORK_REPORT =
  'FETCH_MOBILE_DEVICES_NETWORK_REPORT';
export const FETCH_MOBILE_DEVICES_NETWORK_REPORT_ERROR =
  'FETCH_MOBILE_DEVICES_NETWORK_REPORT_ERROR';
export const SET_MOBILE_DEVICES_NETWORK_REPORT =
  'SET_MOBILE_DEVICES_NETWORK_REPORT';

// Audience Builder
export const FETCH_AUDIENCE_PREVIEW = 'FETCH_AUDIENCE_PREVIEW';
export const FETCH_AUDIENCE_PREVIEW_SUCCESS = 'FETCH_AUDIENCE_PREVIEW_SUCCESS';
export const SET_AUDIENCE_TYPE = ' SET_AUDIENCE_TYPE';
export const SET_INDUSTRY_ACTION = 'SET_INDUSTRY_ACTION';
export const SET_ORGANISATION_ACTION = 'SET_ORGANISATION_ACTION';
export const SET_HOME_ACTION = 'SET_HOME_ACTION';
export const SET_DEMOGRAPHIC_ACTION = 'SET_DEMOGRAPHIC_ACTION';

export const SET_LIFESTAGE_ACTION = 'SET_LIFESTAGE_ACTION';
export const SET_CONTENTGENRES_ACTION = 'SET_CONTENTGENRES_ACTION';
export const SET_AUDIENCE_BUILDER_DATA_SOURCE =
  'SET_AUDIENCE_BUILDER_DATA_SOURCE';
export const SET_AUDIENCE_DATE_RANGE = 'SET_AUDIENCE_DATE_RANGE';
export const CREATE_AUDIENCE = 'CREATE_AUDIENCE';
export const CREATE_AUDIENCE_SUCCESS = 'CREATE_AUDIENCE_SUCCESS';
export const DOWNLOAD_AUDIENCE_BUILDER = 'DOWNLOAD_AUDIENCE_BUILDER';
export const DOWNLOAD_AUDIENCE_BUILDER_SUCCESS =
  'DOWNLOAD_AUDIENCE_BUILDER_SUCCESS';
export const FETCH_INTEGRATIONS = 'FETCH_INTEGRATIONS';
export const FETCH_INTEGRATIONS_SUCCESS = 'FETCH_INTEGRATIONS_SUCCESS';
export const SEND_AUDIENCE_INTEGRATION_JOB = 'SEND_AUDIENCE_INTEGRATION_JOB';
export const SEND_AUDIENCE_INTEGRATION_JOB_SUCCESS =
  'SEND_AUDIENCE_INTEGRATION_JOB_SUCCESS';

export const SET_LAST_INSIGHT_PAGE = 'SET_LAST_INSIGHT_PAGE';
export const SET_LAST_AUDIENCE_BUILDER_PAGE = 'SET_LAST_AUDIENCE_BUILDER_PAGE';
export const SET_LAST_CAMPAIGN_SUMMARY_PAGE = 'SET_LAST_CAMPAIGN_SUMMARY_PAGE';

// Audience campaign summary

export const FETCH_CAMPAIGNS = 'FETCH_CAMPAIGNS';
export const FETCH_CAMPAIGNS_SUCCESS = 'FETCH_CAMPAIGNS_SUCCESS';
export const FETCH_CAMPAIGNS_FAIL = 'FETCH_CAMPAIGNS_FAIL';
export const DELETE_CAMPAIGN = 'DELETE_CAMPAIGN';
export const DELETE_CAMPAIGN_SUCCESS = 'DELETE_CAMPAIGN_SUCCESS';
export const VALIDATE_AUDIENCE_CSV_FILE = 'VALIDATE_AUDIENCE_CSV_FILE';
export const VALIDATE_AUDIENCE_CSV_FILE_SUCCESS =
  'VALIDATE_AUDIENCE_CSV_FILE_SUCCESS';
export const FETCH_SHARE_LIST = 'FETCH_SHARE_LIST';
export const FETCH_SHARE_LIST_SUCCESS = 'FETCH_SHARE_LIST_SUCCESS';
export const FETCH_SHARE_LIST_FAIL = 'FETCH_SHARE_LIST_FAIL';
export const CREATE_CAMPAIGN = 'CREATE_CAMPAIGN';
export const CREATE_CAMPAIGN_SUCCESS = 'CREATE_CAMPAIGN_SUCCESS';
export const SEND_EMAIL_INVITATION = 'SEND_EMAIL_INVITATION';
export const SEND_EMAIL_INVITATION_SUCCESS = 'SEND_EMAIL_INVITATION_SUCCESS';
export const SET_CURRENT_SHARING_CAMPAIGN_ID =
  'SET_CURRENT_SHARING_CAMPAIGN_ID';
export const CAMPAIGN_SIGN_UP = 'CAMPAIGN_SIGN_UP';
export const CAMPAIGN_SIGN_UP_SUCCESS = 'CAMPAIGN_SIGN_UP_SUCCESS';
